// extracted by mini-css-extract-plugin
module.exports = {"s46qnyg":"s46qnyg"};